module.exports = __webpack_public_path__ + "static/media/user.183aa464.svg";